export default "__VITE_ASSET__LQ_artFv__"